import {
  GET_TIPOLOGIAS_REQUEST,
  GET_TIPOLOGIAS_SUCCESS,
  GET_TIPOLOGIAS_FAILURE,
} from '../../constants/tipologias/tipologias.constants';

export const getTipologiasAction = (page, start, limit, filter) => ({
  type: GET_TIPOLOGIAS_REQUEST,
  payload: {
    page, start, limit, filter,
  },
});

export const getTipologiasSuccessAction = (datos, total, page, start, limit) => ({
  type: GET_TIPOLOGIAS_SUCCESS,
  payload: {
    datos, total, page, start, limit,
  },
});

export const getTipologiasFailureAction = error => ({
  type: GET_TIPOLOGIAS_FAILURE,
  payload: error,
});
